<style lang='less' scoped>
@import '../../../style/common/variable';
.banner{position: sticky;top: 0px;background-color: #fff;z-index: 100;}
.app-all {display: none;}
.el-menu-demo {width: 1200px;height: 60px;margin: auto;background: none;border: none;display: flex;justify-content: space-between;}
/deep/.el-menu-item {height: 60px;border-bottom: none;}
/deep/.el-menu-item {font-size: 16px;color: #ffffff;}
/deep/.el-menu-item:hover {background-color: #f5f5f5 !important;color: #ffffff !important;}
/deep/.el-menu-item:focus {background: none !important;}
/deep/.el-menu--horizontal > .el-menu-item.is-active {color: #ffffff;border-bottom: none;}
.mobile-menu {display: none;justify-content: center;}
.mobile-menu-icon {font-size: 24px;cursor: pointer;padding: 15px;}
.mobile-el-menu {display: none;width: 100%;position: absolute;top: 60px;left: 0;background-color: #fff;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);}
.mobile-el-menu-item {width: 100%;text-align: center;padding: 10px;border-bottom: 1px solid #eee;}
.mobile-el-menu-item:hover {background-color: #f5f5f5 !important;}
@media screen and (max-width: @max-screen) {
  .el-menu-demo {display: none;}
  .mobile-menu {display: flex; width: 100%;}
  .mobile-el-menu {display: none;}
  .mobile-el-menu.show {display: block;}
  .mobile-menu-logo{display: flex;justify-content: space-between; width: 100%;}
  .mobile-el-menu-item {font-size: 14px;padding: 10px;}
}
</style>

<template>
  <div class="banner">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      v-if="this.$route.path === '/Promoin' || this.$route.path === '/wjhg' || this.$route.path === '/chbm' || this.$route.path === '/Ltgk' || this.$route.path === '/Ltzlhgk' || this.$route.path === '/NewsList'">
      <el-menu-item
        v-for="(item, id) in menulist"
        :key="id"
        :index="item.sort"
        @click="custormAnchor(item)">
        {{ item.namec }}
      </el-menu-item>
    </el-menu>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      v-else>
      <el-menu-item
        v-for="(item, id) in menulist"
        :key="id"
        :index="item.sort"
        @click="onRouterlink(item)">
        {{ item.namec }}
      </el-menu-item>
    </el-menu>

    <!-- 手机端菜单 -->
    <div class="mobile-menu">
      <div class="mobile-menu-logo">
        <img style="width: 3rem" src="static/index/logo(1).png"/>
        <div class="mobile-menu-icon" @click="toggleMobileMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div class="mobile-el-menu" :class="{ show: isMobileMenuOpen }">
        <div
          class="mobile-el-menu-item"
          v-for="(item, id) in menulist"
          :key="id"
          @click="onRouterlink(item)">
          {{ item.namec }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menulist: { type: Array, default: null }
  },
  data()
  {
    return {
      activeIndex: '1',
      isMobileMenuOpen: false
    }
  },
  mounted()
  {
    this.$nextTick(() =>
    {
      let router = this.$route.name
      this.menulist.forEach(e =>
      {
        if (e.namee === router)
        
          this.activeIndex = e.sort
      })
    })
  },
  methods: {
    onRouterlink(item)
    {
      // 矿业一张图打开新页面
      if (item.namee === 'Kyyztoply')
      {
        let url = this.$router.resolve({ path: '/Kyyztoply' })
        window.open(url.href, '_blank')
      }
      // 数字大屏打开新页面
      else if (item.namee === 'LargeScreen')
      {
        let url = this.$router.resolve({ path: '/LargeScreen' })
        window.open(url.href, '_blank')
      }
      else if (item.namee === 'chbm')
      
        window.open('https://www.camining.cn/nav/index.html', '_blank')
      // else if (item.namee === 'KyyztModule')
      
      //   window.open('https://www.camining.cn/gisdmkydsjpt/#/GxptPage', '_blank')
    
      else
      
        this.$router.push({ name: item.namee })
      
      // 关闭手机端菜单
      if (this.isMobileMenuOpen)
      
        this.isMobileMenuOpen = false
    },
    custormAnchor(item)
    {
      switch (item.namec)
      {
      case '矿业论坛首页':
        this.$router.push({ name: 'Promoin' })
        break
      case '大会新闻':
        this.$router.push({ name: 'Promoin' })
        document.getElementById('dhxw').scrollIntoView({block: 'start', behavior: 'smooth'})
        break
      case '会议日程':
        this.$router.push({ name: 'Promoin' })
        document.getElementById('hyrc').scrollIntoView({block: 'start', behavior: 'smooth'})
        break
      case '演讲嘉宾':
        this.$router.push({name: 'Promoin'})
        document.getElementById('yjjb').scrollIntoView({block: 'start', behavior: 'smooth'})
        break
      case '往届回顾':
        this.$router.push({name: 'wjhg'})
        break
      case '参会报名':
        window.open('https://www.camining.cn/nav/index.html', '_blank')
        break
      default:
      }
      // 关闭手机端菜单
      if (this.isMobileMenuOpen)
      
        this.isMobileMenuOpen = false
    },
    toggleMobileMenu()
    {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    _isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/layout/MenuPanel.vue